import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { IGetAllServiceProps } from "@api/types/globalService.types";
import { getPartnerFrontendBootAPI } from "./partnerFrontend.api";
import { IPartnerFrontendBootResponseSchema } from "./partnerFrontend.types";

type IGetPartnerFrontendBootService = Omit<
  IGetAllServiceProps,
  "page" | "per_page" | "stage_id" | "filters"
>;

function detectPartner() {
  if (import.meta.env.DEV) {
    return "unnao";
  }
  const isPartnerNamePresentInHost =
    location.host?.split(".").length === 4 && location.host?.split(".")?.[0];

  return isPartnerNamePresentInHost || null;
}

const useGetPartnerFrontendBootService = ({
  enableQuery = true,
  cacheKeys = [],
}: IGetPartnerFrontendBootService) => {
  const whichPartner = detectPartner() || "";
  return useQuery({
    queryKey: [...CACHE_KEYS.PARTNER_FRONTEND_BOOT, whichPartner, ...cacheKeys],
    queryFn: (): Promise<{ data: IPartnerFrontendBootResponseSchema }> =>
      getPartnerFrontendBootAPI({ partner: whichPartner }),
    enabled:
      !!whichPartner && enableQuery && import.meta.env.VITE_USER !== "customer",
  });
};

export { useGetPartnerFrontendBootService };
